// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "oitDeclaration";
const shader = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
#define MAX_DEPTH 99999.0
var oitDepthSamplerSampler: sampler;
var oitDepthSampler: texture_2d<f32>;
var oitFrontColorSamplerSampler: sampler;
var oitFrontColorSampler: texture_2d<f32>;
#endif
`;
// Sideeffect
if (!ShaderStore.IncludesShadersStoreWGSL[name]) {
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
}

/** @internal */
export const oitDeclarationWGSL = { name, shader };
